module.exports = __webpack_public_path__ + "static/media/OneScreen.9f49fc52.png";